"use client"
import React, { useState, useEffect } from 'react';
import { FiList } from 'react-icons/fi';

const TableOfContents = () => {
  const [headings, setHeadings] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const article = document.querySelector('.prose');
    if (!article) return;
    
    // Get all h2 and h3 elements
    const elements = Array.from(article.querySelectorAll('h2, h3'));
    
    // Create TOC items with IDs
    const tocItems = elements.map((element, index) => {
      // Create an ID if none exists
      if (!element.id) {
        element.id = `heading-${index}`;
      }
      
      return {
        id: element.id,
        text: element.textContent,
        level: element.tagName === 'H2' ? 2 : 3
      };
    });
    
    setHeadings(tocItems);
  }, []);

  if (headings.length === 0) return null;

  return (
    <div className="sticky top-24 mb-8">
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
        <button 
          className="flex items-center justify-between w-full px-4 py-3 bg-gray-50 text-left text-gray-800 font-medium" 
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="flex items-center">
            <FiList className="mr-2" />
            <span>Table of Contents</span>
          </div>
          <span className="text-sm text-gray-500">{isOpen ? '−' : '+'}</span>
        </button>
        
        {isOpen && (
          <nav className="p-4">
            <ul className="space-y-2 text-sm">
              {headings.map((heading) => (
                <li 
                  key={heading.id}
                  className={`${heading.level === 3 ? 'ml-4' : ''}`}
                >
                  <a 
                    href={`#${heading.id}`}
                    className="text-gray-700 hover:text-blue-600 hover:underline transition-colors"
                    onClick={() => setIsOpen(false)}
                  >
                    {heading.text}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
};

export default TableOfContents; 